// extracted by mini-css-extract-plugin
export default {"productCarousel":"c1-z"};